import { render, staticRenderFns } from "./ForApprovalDisposal.vue?vue&type=template&id=8c78389c"
import script from "./ForApprovalDisposal.vue?vue&type=script&lang=js"
export * from "./ForApprovalDisposal.vue?vue&type=script&lang=js"
import style0 from "./ForApprovalDisposal.vue?vue&type=style&index=0&id=8c78389c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports